import React from "react";
import AppDrawer from "./components/AppDrawer";
import AppFooter from "./components/AppFooter";
import NavegationDesktop from "./components/NavegationDesktop";
import Logo from "../assets/logos/logo-forager-white.svg";
import icon from "../assets/icons/btn-arrow-left.svg";
import { NavLink } from "react-router-dom";
import { ReactComponent as MenuIcon } from "../assets/icons/menu.svg";

export default function MainLayout({ children, styleNav, showLogo, showIconBack  }) {
  return (
    <div className="drawer drawer-end">
      <input id="app-drawer" type="checkbox" className="drawer-toggle" />
      <div className="drawer-content">
        <header className="hidden lg:block absolute top-0 w-full z-50">
          <NavegationDesktop style={styleNav} />
        </header>
        <main className="relative">
          <NavLink to="/">
            <img
              src={Logo}
              alt="Logo Forager Media Group"
              className={`lg:hidden absolute w-32 top-4 left-4 z-50 ${showLogo}`}
            />
          </NavLink>
          {children}
          <label
            htmlFor="app-drawer"
            className="fixed top-3 right-3 grid place-items-center w-12 h-12 rounded-full bg-navy-blue shadow-md cursor-pointer lg:hidden"
          >
            <MenuIcon className="w-8" />
          </label>
          <NavLink to='/companies'>
            <img src={icon} alt="" className={`z-50 fixed left-3 top-3 lg:hidden ${showIconBack ? 'block': 'hidden'} `}  />
          </NavLink>
        </main>
        <AppFooter />
      </div>
      <AppDrawer />
    </div>
  );
}
